import { render, staticRenderFns } from "./course-executor-label.vue?vue&type=template&id=cbf4dd72"
import script from "./course-executor-label.vue?vue&type=script&lang=js"
export * from "./course-executor-label.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports